import { render, staticRenderFns } from "./approved-language-select.vue?vue&type=template&id=4ad9de54&scoped=true&"
import script from "./approved-language-select.vue?vue&type=script&lang=js&"
export * from "./approved-language-select.vue?vue&type=script&lang=js&"
import style0 from "./approved-language-select.vue?vue&type=style&index=0&id=4ad9de54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9de54",
  null
  
)

component.options.__file = "approved-language-select.vue"
export default component.exports